import { useState } from 'react'

import { Button } from '@/components/ui/button'
import {
  WebPanel,
  WebPanelItem,
  WebPanelItemAction,
  WebPanelItemContent,
  WebPanelItemLabel,
} from '@/components/web-panel'
import { DeleteUserModal } from '../modal/DeleteUserModal'

enum EModal {
  None,
  DeleteUser,
}

interface Props {
  canDelete: boolean
}

export const CancelSection = (props: Props): JSX.Element => {
  const [modal, setModal] = useState(EModal.None)

  return (
    <section className="mt-10">
      <h3 className="mb-2.5 text-base font-bold md:mb-3.5 md:text-[17px] lg:mb-5 lg:text-xl">
        アカウントの削除
      </h3>

      <WebPanel>
        <WebPanelItem>
          <WebPanelItemLabel>退会手続き</WebPanelItemLabel>

          <WebPanelItemContent>
            <p className="py-2.5 text-xs font-bold md:text-sm lg:text-[13px]">
              アカウントを削除すると、学習履歴を含むお客様のすべての情報が完全に削除されます。
            </p>
          </WebPanelItemContent>

          <WebPanelItemAction>
            <Button
              variant="outline"
              size="sm"
              className="ml-2 h-[38px] w-[52px] rounded-lg text-xs md:h-[44px] md:w-[74px] md:rounded-xl md:text-[15px] lg:w-[80px]"
              onClick={() => {
                setModal(EModal.DeleteUser)
              }}
            >
              退会
            </Button>
          </WebPanelItemAction>
        </WebPanelItem>
      </WebPanel>
      <DeleteUserModal
        isOpen={modal === EModal.DeleteUser}
        canDelete={props.canDelete}
        onRequestClose={() => {
          setModal(EModal.None)
        }}
      />
    </section>
  )
}
